module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0028.jpg?v=27662868";